<template>
  <div class="widget automation reactivation">
    <p-progress-linear v-if="vm.isLoading" indeterminate></p-progress-linear>
    <div v-if="!vm.isContactIdSet" class="contactsearch wrapper">
      <p-form :model="vm.formSearchModel">
        <p>{{ $t('widget.automation.contact.search.description') }}</p>
        <p-row class="input">
          <p-col xs12 md4>
            <p-text-field v-model="vm.formSearchModel.customerNumber" :label="$t('widget.automation.contact.search.memberNumber')"></p-text-field>
          </p-col>
          <p-col xs12 md4>
            <p-text-field v-model="vm.formSearchModel.lastName" :label="$t('core.address.lastName')"></p-text-field>
          </p-col>
          <p-col xs12 md4 class="pt-7">
            <p-button @click="searchContactClick">
              {{ $t('core.app.search') }}
            </p-button>
          </p-col>
        </p-row>
        <div class="contact mb-6">
          <p-fieldset class="contact" :label="$t('widget.automation.contact.label')">
            {{ $t(`widget.automation.contact.search.notFoundMessage.text`) }} <a target="_blank" :href="$t(`widget.automation.contact.search.notFoundMessage.link.${vm.tenantKey}`)">{{ $t(`widget.automation.contact.search.notFoundMessage.link.${vm.tenantKey}`) }}</a>
          </p-fieldset>
        </div>
      </p-form>
    </div>
    <div v-if="vm.isContactLoaded && !vm.isSubmitted" class="reactivation wrapper">
      <p-form :model="vm.formReactivationModel" :schema="vm.formReactivationModel.schema">
        <div class="contact mb-6">
          <p-fieldset class="contact" :label="$t('widget.automation.contact.label')">
            <div v-html="vm.contactResultDisplay"></div>
          </p-fieldset>
        </div>
        <div class="preferences mb-6">
          <p-fieldset class="contact" :label="$t('widget.automation.donation.label')">
            <div v-for="(item) in vm.donationItems" :key="item.id">
              <p-radio-field v-model="vm.formReactivationModel.donationItem" class="mb-3" name="donation" :label="item.caption" :true-value="item.id"></p-radio-field>
            </div>
          </p-fieldset>
          <p-checkbox-group v-model="vm.formReactivationModel.characteristicItems" :label="$t('widget.automation.preferences.label.gift')" :items="vm.characteristicItems"></p-checkbox-group>

          <p-fieldset class="contact" :label="$t('widget.automation.preferences.label.marketing')">
            <p-row class="type">
              <p-col xs12>
                <p-checkbox-group v-model="vm.formReactivationModel.newsletterItems" :items="vm.newsletterItems"></p-checkbox-group>
              </p-col>
            </p-row>
            <p-row class="email">
              <p-col xs12 md4>
                <p-text-field v-model="vm.formReactivationModel.contact.email" :label="$t('core.address.email')" required></p-text-field>
              </p-col>
            </p-row>
          </p-fieldset>
        </div>
        <div class="address">
          <h4>{{ $t('widget.automation.address.sectionTitle') }}</h4>
          <p>{{ $t('widget.automation.address.sectionIntro') }}</p>
          <p-row class="street">
            <p-col xs12 md10>
              <p-text-field v-model="vm.formReactivationModel.contact.street" :label="$t('core.address.street')" required></p-text-field>
            </p-col>
            <p-col xs12 md2>
              <p-text-field v-model="vm.formReactivationModel.contact.houseNumber" :label="$t('core.address.houseNumber')"></p-text-field>
            </p-col>
          </p-row>
          <p-row class="city">
            <p-col xs12 md2>
              <p-text-field v-model="vm.formReactivationModel.contact.postalCode" :label="$t('core.address.postalCode')" required></p-text-field>
            </p-col>
            <p-col xs12 md10>
              <p-text-field v-model="vm.formReactivationModel.contact.city" :label="$t('core.address.city')" required></p-text-field>
            </p-col>
          </p-row>
          <p-row class="message">
            <p-col xs12>
              <p-textarea v-model="vm.formReactivationModel.message" :label="$t('widget.automation.message.label')">
              </p-textarea>
            </p-col>
          </p-row>
        </div>
      </p-form>
    </div>
    <p-request-alert
      v-if="_.isSet(vm.error)"
      v-model="vm.error"
      class="mb-3 mt-3"
    ></p-request-alert>
    <p-alert type="success" class="mb-3 mt-3" :value="vm.isSubmitted">
      {{ $t('widget.automation.submitSuccessMessage') }}
    </p-alert>
    <div v-if="vm.isContactDataPrefilled && !vm.isLoading && !vm.isSubmitted" class="action">
      <p-row class="button">
        <p-col justify-end>
          <p-button :disabled="!vm.canSubmitForm" :loading="vm.isSubmitting" @click="vm.onSubmitClick()">
            {{ $t('core.app.send') }}
          </p-button>
          <p-button class="ml-5" :disabled="!vm.canSubmitForm" :loading="vm.isSubmitting" @click="vm.onSubmitAndRedirectClick()">
            {{ $t('widget.automation.submitAndRedirect') }}
          </p-button>
        </p-col>
      </p-row>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import AutomationReactivationVM from './reactivation.vue.model';

  export default Vue.extend({
    layout: 'layout-widget',
    props: {
      contactId: { default: undefined, type: String },
      tenantKey: { default: undefined, type: String },
      mountId: { default: undefined, type: String },
      submitRedirectUrl: { default: undefined, type: String },
      submitAndDonateRedirectUrl: { default: undefined, type: String },
    },
    data: () => ({
      vm: new AutomationReactivationVM(),
      formSummary: {},
      isEmailRequired: false,
    }),
    computed: {
      // read from widget config
      innerContactId(): string {
        if (this._.isSet(this.contactId)) {
          return this.contactId;
        }
        if (this.$config.values['widget-dynamicform-contactid']) {
          return this.$config.values['widget-dynamicform-contactid'];
        }
        const queries = this.$routerUtils.getQueryParams();
        return queries.contactid as string;
      },
      innerTenantKey(): string {
        if (this._.isSet(this.tenantKey)) {
          return this.tenantKey.toLowerCase();
        }
        if (this.$config.values['widget-tenant-key']) {
          return this.$config.values['widget-tenant-key'];
        }
        const queries = this.$routerUtils.getQueryParams();
        if (queries.tenantKey) { return queries.tenantKey?.toLowerCase() as string; }
        return 'kls';
      },
      innerRedirectSubmitUrl(): string {
        if (this._.isSet(this.submitRedirectUrl)) {
          return this.submitRedirectUrl.toLowerCase();
        }
        if (this.$config.values['widget-submit-redirect-url']) {
          return this.$config.values['widget-submit-redirect-url'];
        }
        const queries = this.$routerUtils.getQueryParams();
        if (queries.submitRedirectUrl) { return queries.submitRedirectUrl.toLowerCase() as string; }
        return '';
      },
      innerRedirectSubmitAndDonateUrl(): string {
        if (this._.isSet(this.submitRedirectUrl)) {
          return this.submitAndDonateRedirectUrl.toLowerCase();
        }
        if (this.$config.values['widget-submitanddonate-redirect-url']) {
          return this.$config.values['widget-submitanddonate-redirect-url'];
        }
        const queries = this.$routerUtils.getQueryParams();
        if (queries.submitAndDonateRedirectUrl) { return queries.submitAndDonateRedirectUrl.toLowerCase() as string; }
        return '';
      },
    },
    mounted() {
      this.vm.contactId = this.innerContactId;
      this.vm.tenantKey = this.innerTenantKey;
      this.vm.submitRedirectUrl = this.innerRedirectSubmitUrl;
      this.vm.submitAndDonateRedirectUrl = this.innerRedirectSubmitAndDonateUrl;
      this.vm.initialize();
    },
    methods: {
      searchContactClick() {
        this.vm.searchContact();
      },
    },
  });
</script>
